<template>
  <div class="check-list-person auto-list_col_centered">
    <p class="date">{{ response.request_phone }}</p>
  </div>
</template>

<script>
import { statuses } from '@/datas/responseStatuses'
import { unixTimeStampToDate } from '@/helpers/date'

export default {
  name: 'PhoneInProgress',
  props: {
    response: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="sass">
.bids-list .middle-section .check-list .check-list-person
  .date
    font-size: 15px
    line-height: 14px
    color: #8694A4
    margin: 10px 0
    &.status
      text-decoration: underline
    &.info
      color: #909399
    &.success
      color: #67C23A
    &.warning
      color: #E6A23C
    &.danger
      color: #F56C6C
</style>
